export const sanitizedHtmlTags = {
  allowedTags: [
    "blockquote",
    "p",
    "a",
    "ul",
    "ol",
    "li",
    "b",
    "i",
    "s",
    "strong",
    "u",
    "em",
    "strike",
    "del",
    "br",
    "div",
    "sup",
    "sub",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "img",
    "figure",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr",
    "th",
    "td",
    "iframe",
    "oembed",
    "mark",
  ],
  allowedAttributes: {
    a: ["href", "name", "target"],
    img: ["src"],
    iframe: [
      "src",
      "width",
      "height",
      "frameborder",
      "allowm",
      "allowfullscreen",
    ],
    oembed: ["url"],
    "*": [
      "style",
      "class",
      "id",
      "aria-label",
      "aria-hidden",
      "role",
      "alt",
      "title",
    ],
  },
  selfClosing: [
    "img",
    "br",
    "hr",
    "area",
    "base",
    "basefont",
    "input",
    "link",
    "meta",
  ],
  allowedSchemes: ["http", "https", "ftp", "mailto"],
  allowedSchemesByTag: {},
};

export const localHtml = `
<h1>Artigo de teste&nbsp;</h1>
<p>Ancoragem:<br>
<a href="#testeh1">h1&nbsp;</a>
<a href="#testeh2">h2&nbsp;</a>
<a href="#testeh3">h3&nbsp;</a>
<a href="#testeh4">h4&nbsp;</a>
<a href="#testeh5">h5&nbsp;</a>
<a href="#testeh6">h6&nbsp;</a>
<p>&nbsp;</p>

<strong>Teste de responsividade dos títulos</strong>
<h1>Consequat Lorem id ea duis.Est ea labore incididunt quis.</h1>

<h1 id="testeh1">h1</h1>
<p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
<h2 id="testeh2">h2</h2>
<p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
<h3 id="testeh3">h3</h3>
<p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
<h4 id="testeh4">h4</h4>
<p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
<h5 id="testeh5">h5</h5>
<p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
<h6 id="testeh6">h6</h6>
<p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.<br>&nbsp;</p>
<p><strong>Lista</strong>&nbsp;</p>
<ul>
  <li>item a</li>
  <li>item b</li>
  <li>item c</li>
</ul>
<p>&nbsp;</p>
<p><strong>Check list</strong></p>
<ul class="todo-list">
  <li><label class="todo-list__label"><strong><input type="checkbox" disabled="disabled" checked="checked"></strong><span class="todo-list__label__description"><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span></label></li>
  <li><label class="todo-list__label"><strong><input type="checkbox" disabled="disabled" checked="checked"></strong><span class="todo-list__label__description"><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span></label></li>
  <li><label class="todo-list__label"><strong><input type="checkbox" disabled="disabled" checked="checked"></strong><span class="todo-list__label__description"><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span></label></li>
</ul>
<p>&nbsp;</p>
<p><strong>Lista numérica</strong></p>
<ol>
  <li><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</li>
  <li><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</li>
  <li><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</li>
</ol>
<p>&nbsp;</p>
<p><br><strong>"warning", "info", "error"</strong></p>
<div class="olist-alert-info">
  <p>info test</p>
</div>
<div class="olist-alert-warning">
  <p>warning test</p>
</div>
<div class="olist-alert-error">
  <p>error test</p>
</div>
<p><br><br><strong>Tabela</strong><br>&nbsp;</p>
<figure class="table">
  <table>
    <tbody>
      <tr>
        <td>testetestetesteteste</td>
        <td>testetestetestetesteteste</td>
        <td>testetestetestetesteteste</td>
        <td>testetesteteste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>testes</td>
        <td>testes</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>testes</td>
        <td>testes</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>testes</td>
        <td>testes</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>testes</td>
        <td>testes</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>testes</td>
        <td>testes</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
        <td>teste</td>
      </tr>
      <tr>
        <td>teste</td>
        <td>teste</td>
        <td>testes</td>
        <td>testes</td>
      </tr>
    </tbody>
  </table>
</figure>

<table>
  <tbody>
    <tr>
      <th>Permite estoque negativo</th>
      <td>Ao selecionar a opção<strong> Não - Validar os saldos de todos os depósitos com saldos a considerar</strong> , não será permitido lançar estoque de notas fiscais, pedidos de venda e ordens de serviço caso o saldo de algum dos produtos for insuficiente em todos os estoques que consideram saldo. Se escolher a opção<strong> Não - Validar o saldo do depósito selecionado na venda</strong> , não permitirá lançar estoque de notas fiscais, pedidos de venda e ordens de serviço caso o saldo de algum dos produtos for insuficiente. Para as vendas e notas fiscais, será considerado o depósito selecionado. Para as ordens de serviço, será considerado o depósito padrão. Caso selecione a opção<strong> Sim</strong> , poderá lançar estoque das vendas, mesmo os produtos não possuindo saldo em estoque.</td>
    </tr>
    <tr>
      <th>Bloquear autorização de Notas Fiscais com saldo de estoque igual ou inferior a zero</th>
      <td>Visível quando o parâmetro<strong> permite estoque negativo</strong> for marcado como <strong>não</strong>. Habilitando esse parâmetro, sempre que um item tiver saldo em estoque igual ou inferior a zero, de acordo com a configuração anterior, as notas fiscais <strong>não serão emitidas</strong>.&nbsp;</td>
    </tr>
    <tr>
      <th>Lançamento de estoque para saídas</th>
      <td>
        <p>Ao selecionar a opção<strong> Manual</strong> , o usuário deverá através do menu de contexto localizado ao lado de cada pedido ou nota fiscal selecionar a opção<strong> Lançar estoque</strong>. Se escolhida uma das opções de<strong> Automático</strong> , o sistema fará o lançamento no momento determinado:<strong> Ao autorizar a NFe</strong> ,<strong> Ao salvar NFe</strong> ,<strong> Ao salvar o pedido</strong> ou<strong> Ao marcar pedido como enviado</strong>. Se selecionar<strong> Ao marcar pedido como enviado</strong> e o pedido tiver uma nota fiscal vinculada, o lançamento de estoque ocorrerá pela nota fiscal.</p>
        <p>* O lançamento do estoque pode ser parametrizado de acordo com as <a href="https://ajuda.olist.com/kb/erp/notas-fiscais-e-tributacao/naturezas-de-operacao/natureza-de-operacao-de-saida-de-mercadorias">configurações das naturezas de operação</a>. Ao lançar estoque manual para uma natureza configurada para não permitir lançamento de estoque, será exibido um aviso não permitindo lançar estoque. A configuração da natureza de operação deverá ser verificada.</p>
      </td>
    </tr>
    <tr>
      <th>Lançamento de estoque para entradas</th>
      <td>Quando selecionada a opção<strong> Manual</strong> , o usuário deverá através do menu de contexto localizado ao lado de cada pedido de compra ou nota fiscal de entrada, selecionar a opção<strong> Lançar estoque</strong>. Se escolhida uma das opções de<strong> Automático</strong> , o sistema fará o lançamento no momento determinado:<strong> Ao autorizar a NFe, Ao salvar NFe, Ao salvar o pedido </strong>ou ao<strong> finalizar conferência de compra</strong>, quando desejar que o estoque seja lançado automático após concluir a conferência das notas de entrada, através do recurso <a href="https://ajuda.olist.com/kb/erp/suprimentos/compras/conferencia-de-compra">Conferência de Compra</a>.</td>
    </tr>
    <tr>
      <th>Lançamento de estoque para serviços</th>
      <td>Quando selecionada a opção<strong> Manual</strong> , o usuário deverá através do menu de contexto localizado ao lado de cada ordem de serviço, selecionar a opção<strong> Lançar estoque</strong>. Se escolhida a opção<strong> Automático ao salvar a ordem de serviço</strong> , o sistema fará o lançamento no momento determinado.</td>
    </tr>
    <tr>
      <th>Estorno de estoques</th>
      <td>Marque <strong>Manual</strong> ou <strong>Automático ao cancelar nota fiscal</strong> para definir a forma de estorno do estoque ao cancelar ou excluir uma nota.</td>
    </tr>
    <tr>
      <th>Exibir estoque do produto na lista de preços</th>
      <td>Ao habilitar a opção será apresenta a informação no relatório disponibilizado em:<strong> Cadastros → Relatórios → Lista de Preços</strong>.</td>
    </tr>
    <tr>
      <th>Estornar automaticamente ao cancelar o pedido</th>
      <td>Habilite esse parâmetro para que o estoque seja estornado automaticamente quando um pedido for cancelado.</td>
    </tr>
    <tr>
      <th>Enviar e-mail sobre produtos abaixo do estoque mínimo</th>
      <td>
        <p>Ao habilitar a opção você receberá em seu e-mail o relatório dos produtos abaixo do estoque mínimo. O e-mail deve ser informado no campo<strong> Endereço de e-mail para receber os avisos</strong>.</p>
        <p>* Para definir o estoque mínimo, edite o produto cadastrado e informe a quantidade desejada.</p>
      </td>
    </tr>
    <tr>
      <th>Endereço de e-mail para receber os avisos</th>
      <td>Informe o e-mail que receberá os avisos dos produtos abaixo do estoque mínimo. Os avisos são enviados por e-mail no período da noite.</td>
    </tr>
  </tbody>
</table>

<p><br><br><strong>Imagem</strong></p>
<figure class="image"><img src="/erp/notas-fiscais-e-tributacao/relatório de numerações - período.jpg"></figure>
<div class="video-frame">
  <iframe allowfullscreen="" frameborder="0" height="546" src="https://www.youtube.com/embed/vn4jUKEyt4E" width="970"></iframe>
</div>
`;
